import { STRINGS } from '../assets/strings/Strings'
import * as Constants from './Constants'

/**
 * Parse to date on format 'YYYY-MM-DD'
 * @param date Date object
 */
export function parseDate(date) {
  return (
    date.getFullYear() +
    '-' +
    fill(1 + date.getMonth()) +
    '-' +
    fill(date.getDate())
  )
}

export function compareDate(date1, date2) {
  date1.setHours(0, 0, 0, 0)
  date2.setHours(0, 0, 0, 0)
  return date1.getTime() === date2.getTime()
}

export function laundryTimePassed(date, endTime) {
  const currentDate = new Date()
  const laundryTime = date

  laundryTime.setHours(endTime.split(':')[0])
  laundryTime.setMinutes(endTime.split(':')[1])

  return currentDate.getTime() - laundryTime.getTime() > 0
}

export function getAndSortTodaysLaundryTimes(times, date) {
  return times
    .sort((o1, o2) => {
      if (o1.startTime > o2.startTime) {
        return 1
      }

      return -1
    })
    .filter(t => {
      const days = t.days.split(';')

      return days.indexOf(Constants.WEEKDAYS_JS[date.getDay()]) !== -1
    })
}

export function formatDate(date) {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  if (date) {
    const day = date.getDate()
    const monthIndex = date.getMonth() + 1
    const year = date.getFullYear()
    let monthIndexString = monthIndex
    if (monthIndex < 10) {
      monthIndexString = '0' + monthIndex
    }
    let dayString = day
    if (day < 10) {
      dayString = '0' + day
    }

    return year + '-' + monthIndexString + '-' + dayString
  }
  return null
}

/**
 * Check if a booking exists in the given array
 * @param bookigns array
 * @param timeId
 * @param laundryId
 * @param date
 */
export function isBooked(bookings, timeId, laundryId, date) {
  let bookingToReturn = null
  bookings.forEach(booking => {
    if (
      booking.timeId.toString() === timeId.toString() &&
      booking.laundryId.toString() === laundryId.toString() &&
      booking.date.toString() === date.toString()
    )
      bookingToReturn = booking
  })
  return bookingToReturn
}

/**
 * Sorts array with objects, largest first
 */
export function sortArrayAsc(array, key) {
  array.sort((o1, o2) => {
    if (!o1[key]) return 1
    else if (!o2[key]) return -1
    return o1[key].toString() < o2[key].toString() ? -1 : 1
  })
  return array
}

/**
 * Sorts array with objects, smallest first
 */
export function sortArrayDesc(array, key) {
  array.sort((o1, o2) => {
    if (!o1[key]) return -1
    else if (!o2[key]) return 1
    return o1[key].toString() < o2[key].toString() ? 1 : -1
  })
  return array
}

//Checks if a value exists in an array, converts to lowercase and string first.
export function inArray(array, value) {
  let inArray = false
  array.forEach(item => {
    if (item.toString().toLowerCase() === value.toString().toLowerCase())
      inArray = true
  })
  return inArray
}

//Checks index of with special key
export function getIndexOf(array, value, key) {
  let index = -1
  array.forEach((item, i) => {
    if (item[key] === value) index = i
  })
  return index
}

export function getString(key, language) {
  return STRINGS[key][language]
}

export function fill(str) {
  if (str.toString().length === 1) return '0' + str
  return str
}

export function parseType(type, language, one = true) {
  switch (type) {
  case 'S':
    return one
      ? getString('washhouse', language)
      : getString('washhouses', language)
  case 'M':
    return one
      ? getString('laundryMachine', language)
      : getString('laundryMachines', language)
  default:
  }
}

/** @return true if time1 is lesser then time2 */
export function timeIsLesser(time1, time2) {
  const time1Array = time1.split(':')
  const time2Array = time2.split(':')
  const time1Hour = parseInt(time1Array[0], 10)
  const time2Hour = parseInt(time2Array[0], 10)
  const time1Min = parseInt(time1Array[1], 10)
  const time2Min = parseInt(time2Array[1], 10)
  if (time1Hour < time2Hour) return true
  if (time1Hour === time2Hour && time1Min < time2Min) return true
  return false
}

/** @return true if time1 is greater then time2 */
export function timeIsGreater(time1, time2) {
  const time1Array = time1.split(':')
  const time2Array = time2.split(':')
  const time1Hour = parseInt(time1Array[0], 10)
  const time2Hour = parseInt(time2Array[0], 10)
  const time1Min = parseInt(time1Array[1], 10)
  const time2Min = parseInt(time2Array[1], 10)
  if (time1Hour > time2Hour) return true
  if (time1Hour === time2Hour && time1Min > time2Min) return true
  return false
}

export function timeIsOverlapping(
  newStartTime,
  startTime,
  newEndTime,
  endTime
) {
  const newStartTimeArray = newStartTime.split(':')
  const startTimeArray = startTime.split(':')
  const newEndTimeArray = newEndTime.split(':')

  const newStartHour = parseInt(newStartTimeArray[0], 10)
  const startHour = parseInt(startTimeArray[0], 10)
  const newEndHour = parseInt(newEndTimeArray[0], 10)

  const newStartMin = parseInt(newStartTimeArray[1], 10)
  const startMin = parseInt(startTimeArray[1], 10)
  const newEndMin = parseInt(newEndTimeArray[1], 10)

  const startTimeLesserThenStart =
    newStartHour <= startHour ||
    (newStartHour === startHour && newStartMin <= startMin)
  const endTimeLargerThenStart =
    newEndHour > startHour || (newEndHour === startHour && newEndMin > startMin)
  const startTimeLargerThenEnd =
    newStartHour >= startHour ||
    (newStartHour === startHour && newStartMin >= startMin)
  const endTimeLesserThenStart =
    newEndHour < startHour || (newEndHour === startHour && newEndMin < startMin)
  if (startTimeLesserThenStart && endTimeLargerThenStart) return true
  if (startTimeLargerThenEnd && endTimeLesserThenStart) return true
  return false
}

export function isEarlier(startTime, endTime) {
  const startTimeArray = startTime.split(':')
  const endTimeArray = endTime.split(':')
  const startHour = parseInt(startTimeArray[0], 10)
  const endHour = parseInt(endTimeArray[0], 10)
  const startMin = parseInt(startTimeArray[1], 10)
  const endMin = parseInt(endTimeArray[1], 10)
  if (startHour > endHour) return true
  else if (startHour === endHour && startMin >= endMin) return true
  return false
}

// id is set to null if it's a new time that is being created
export function isOverlapping(myTimes, newStartTime, newEndTime, id) {
  let overlapping = false
  const times = myTimes.filter(time => time.id !== id)
  times.forEach(time => {
    const { startTime, endTime } = time
    const startTimeOverlapping =
      timeIsLesser(newStartTime, endTime) &&
      timeIsGreater(newStartTime, startTime)
    const endTimeOverlapping =
      timeIsLesser(newEndTime, endTime) && timeIsGreater(newEndTime, startTime)
    if (
      startTimeOverlapping ||
      endTimeOverlapping ||
      timeIsOverlapping(newStartTime, startTime, newEndTime, endTime)
    )
      overlapping = true
  })
  return overlapping
}

export function toClosest99(x) {
  const lastDigit = parseInt(x.toString()[x.toString().length - 1], 10)
  if (lastDigit < 5) return x - (lastDigit + 1)
  else if (lastDigit !== 9) return x + (9 - lastDigit)
  return x
}

export function calculatePricePerApartment(apartments, language) {
  if (apartments === 100) return getString('contactUs', language)
  const total = calculateTotalPrice(apartments, language)
  return total === '-' ? '-' : (total / apartments).toFixed(2)
}

export function calculateTotalPrice(apartments, language) {
  const x = apartments
  if (apartments === 100) return getString('contactUs', language)
  const totalPrice = x
    ? toClosest99(
      parseInt(
        218.5505 +
            (88.76078 - 218.5505) / Math.pow(1 + x / 38.40201, 1.826435),
        10
      )
    )
    : '-'
  return totalPrice
}

export function isValidEmail(email) {
  //eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return re.test(String(email).toLowerCase())
}

export function validatePhoneNumber(number) {
  const regex = /[+]?[0-9 ]+/
  return regex.test(String(number).toLowerCase())
}

export function validateURL(url) {
  const regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/
  return regex.test(String(url).toLowerCase())
}

export function timePassed(date, endTime) {
  const currentDate = new Date()
  const time = date

  time.setHours(endTime.split(':')[0])
  time.setMinutes(endTime.split(':')[1])

  return currentDate.getTime() - time.getTime() > 0
}

export function getTimeAgo(date) {
  const today = new Date()
  const formatDate = date.replace(/:|T/g, '-')
  const YMDhms = formatDate.split('-')
  const dateYear = parseInt(YMDhms[0], 10)
  const dateMonth = parseInt(YMDhms[1], 10)
  const dateDay = parseInt(YMDhms[2], 10)
  const dateHours = parseInt(YMDhms[3], 10) + 2
  const dateMinutes = parseInt(YMDhms[4], 10)

  if (
    dateYear === today.getFullYear() &&
    dateMonth === today.getMonth() + 1 &&
    dateDay === today.getDate()
  ) {
    if (dateHours === today.getHours()) {
      const diffMins = today.getMinutes() - dateMinutes

      if (diffMins < 0) {
        return '0 min'
      }

      return diffMins + ' min'
    } else if (dateHours + 1 === today.getHours()) {
      const minutesUntilWhole = 60 - dateMinutes
      const minutesSincePost = minutesUntilWhole + today.getMinutes()

      return minutesSincePost + ' min'
    }
    const diffHours = today.getHours() - dateHours

    if (diffHours < 0) {
      return '0 min'
    }

    return diffHours + ' h'
  } else if (
    dateYear === today.getFullYear() &&
    dateMonth === today.getMonth() + 1
  ) {
    return today.getDate() - dateDay + ' d'
  }

  return (
    dateYear +
    '-' +
    YMDhms[1] +
    '-' +
    YMDhms[2] +
    ' ' +
    YMDhms[3] +
    ':' +
    YMDhms[4] +
    ':' +
    YMDhms[5].split('.')[0]
  )
}



// WEBPACK FOOTER //
// ./src/helpers/Functions.js